import Vue from "vue";
import api from "./api";
import { normalizeRouteVias } from "./utils";

const SET_ACTIVE_ROUTE = "SET_ACTIVE_ROUTE";
const TRANSFER_ROUTE = "TRANSFER_ROUTE";
const UPDATE_ROUTE = "UPDATE_ROUTE";

const namespaced = true;

const state = {
  active: _getRoute(),
  cache: _getRoute(),
};

function _getRoute() {
  return JSON.parse(localStorage.getItem("route") || "{}");
}

const mutations = {
  SET_ACTIVE_ROUTE(state, data) {
    state.active = data || {};
    state.cache = { ...data };

    localStorage.setItem("route", JSON.stringify(state.active));
  },
  TRANSFER_ROUTE(state) {
    state.cache = { ...state.active };
    localStorage.setItem("route", JSON.stringify(state.cache));
  },
  UPDATE_ROUTE(state, { key, val }) {
    Vue.set(state.active, key, val);
  },
};

const actions = {
  setRoute({ commit }, data) {
    commit(SET_ACTIVE_ROUTE, data);
  },
  setUpdate({ commit }, { key, val }) {
    commit(UPDATE_ROUTE, { key, val });
  },

  getRouteList({ commit }, data) {
    return api
      .getRouteList(data)
      .then((data) => data.data)
      .catch((err) => {
        if (err) throw err.data;
      });
  },
  getRoutesByCities({ commit }, { cityStart, cityEnd }) {
    return api
      .getRoutesByCities(cityStart, cityEnd)
      .then((data) => data.data)
      .catch((err) => {
        if (err) throw err.data;
      });
  },
  getRouteCount({ commit }, data) {
    return api
      .getRouteCount(data)
      .then((data) => Object.values(data.data)[0])
      .catch((err) => {
        if (err) throw err.data;
      });
  },
  getOneRoute({ commit }, route_id) {
    return api
      .getOneRoute(route_id)
      .then((data) => {
        commit(SET_ACTIVE_ROUTE, data.data);
        return data.data;
      })
      .catch((err) => {
        if (err) throw err.data;
      });
  },
  fetchRouteById({ commit }, route_id) {
    return api
      .getOneRoute(route_id)
      .then((data) => data.data)
      .catch((err) => {
        if (err) throw err.data;
      });
  },
  addRoute({ commit }, data) {
    const payload = {
      ...data,
      vias: normalizeRouteVias(data && data.vias),
    };
    return api
      .addRoute(payload)
      .then((data) => data.data)
      .catch((err) => {
        if (err) throw err.data;
      });
  },
  updateRoute({ commit, state }, data) {
    var id = data ? data.route_id : state.active.id;
    var update = data ? data.data : state.active;
    const payload = {
      ...update,
      vias: normalizeRouteVias(update && update.vias),
    };

    return api
      .updateRoute(id, payload, state.cache)
      .then((v) => {
        commit(UPDATE_ROUTE, { key: "vias", val: payload.vias });
        commit(TRANSFER_ROUTE);
      })
      .catch((err) => {
        if (err) throw err.data;
      });
  },
  deleteRoute({ commit, state }, route_id) {
    var delete_id = route_id || state.active.id;
    return api
      .deleteRoute(delete_id)
      .then((v) => commit(SET_ACTIVE_ROUTE, {}))
      .catch((err) => {
        if (err) throw err.data;
      });
  },
  checkRouteInQuote({ commit }, route_id) {
    return api
      .checkRouteInQuote(route_id)
      .then((data) => data.data)
      .catch((err) => {
        if (err) throw err.data;
      });
  },
};

const getters = {
  id: (state) => (state.active ? state.active.id : ""),
  active: (state) => state.active || {},
  cache: (state) => state.cache || {},

  hasChanges: (state) => {
    let current = JSON.stringify(state.active);
    let cached = JSON.stringify(state.cache);
    if (current === cached) return false;
    return true;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
